import React from "react";

export interface StatCardProps {
  label: string;
  value: number | string;
  /** Border-top + value color. Defaults to a neutral/transparent look. */
  color?: string;
  /** Small supporting line under the value (e.g. "ready to claim"). */
  note?: string;
}

/**
 * Small KPI tile — background card, colored top border, uppercase label,
 * big value, optional note. Shared by FleetOverview's stat row and
 * HostTopology's KPI row (see accepted spec §5) so both stay visually
 * identical without duplicating the markup.
 */
export default function StatCard({ label, value, color, note }: StatCardProps) {
  return (
    <div
      style={{
        background: "var(--color-surface)",
        borderRadius: "var(--radius-md)",
        boxShadow: "var(--shadow-card)",
        padding: "var(--space-lg)",
        display: "flex",
        flexDirection: "column",
        borderTop: `3px solid ${color ?? "transparent"}`,
      }}
    >
      <span
        style={{
          fontSize: "var(--font-size-sm)",
          color: "var(--color-text-secondary)",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          fontWeight: 600,
          marginBottom: "var(--space-xs)",
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontSize: "var(--font-size-stat)",
          fontWeight: 700,
          color: color ?? "var(--color-text-primary)",
        }}
      >
        {value}
      </span>
      {note && (
        <span
          style={{
            fontSize: "var(--font-size-xs)",
            color: "var(--color-text-secondary)",
            marginTop: "var(--space-xs)",
          }}
        >
          {note}
        </span>
      )}
    </div>
  );
}
